import { render, staticRenderFns } from "./TabFundadores.vue?vue&type=template&id=2bc4c22a"
import script from "./TabFundadores.vue?vue&type=script&lang=ts"
export * from "./TabFundadores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports